module.exports = __webpack_public_path__ + "static/img/activitytopic_detail.00fd634.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/appBackend/assets/example/activitytopic_detail.jpg
// module id = 1105
// module chunks = 2